module.exports = __webpack_public_path__ + "static/media/bottle-sparkling.2d717ac9.png";